import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/events/record';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(data) {
  try {
    const { json } = data.payload;
    const response = yield call(
      axios.post,
      `${config.API_URL}/event/record`,
      json,
      { headers: getLocalUser() }
    );
    yield put(fetchSuccess(response.data.data));
  } catch (error) {
    console.error(error);
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
